export default __webpack_public_path__ + "static/logo-b226177bba323c8b2a145dd93e05f69d.svg";